export class RuntimeApiBaseError extends Error {
  constructor(code, message) {
    super(message);
    this.name = "RuntimeApiBaseError";
    this.code = code;
  }
}

export const normalizeRuntimeApiBaseUrl = (value) => {
  const raw = String(value || "").trim();
  if (!raw) {
    throw new RuntimeApiBaseError(
      "tenant_context_mismatch",
      "Tenant runtime API endpoint is unavailable.",
    );
  }

  let parsed;
  try {
    parsed = new URL(raw);
  } catch (_error) {
    throw new RuntimeApiBaseError(
      "tenant_context_mismatch",
      "Tenant runtime API endpoint is invalid.",
    );
  }
  if (
    !["http:", "https:"].includes(parsed.protocol)
    || parsed.username
    || parsed.password
    || parsed.search
    || parsed.hash
  ) {
    throw new RuntimeApiBaseError(
      "tenant_context_mismatch",
      "Tenant runtime API endpoint is invalid.",
    );
  }

  const path = parsed.pathname.replace(/\/+$/, "");
  const apiPath = /\/api\/v1$/i.test(path) ? path : `${path}/api/v1`;
  return `${parsed.origin}${apiPath}`;
};

export const treatmentRuntimeApiUrl = (apiBaseUrl, path) => (
  `${normalizeRuntimeApiBaseUrl(apiBaseUrl)}${path}`
);
